module.exports = __webpack_public_path__ + "img/tz.f56b4e23.svg";